import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useUpdateRewardSettingsMutation } from "../../redux/rewardSettingsApi";
import { useGetCryptocurrencyQuery } from "../../redux/cryptocurrencyApi";

import { toast } from "react-toastify";

import { useTranslation } from "react-i18next";

function EditRewardSettings({ show, onHide, rewardSettings }) {
    const { t } = useTranslation();
    const [editData, setEditData] = useState({});
    const [updateRewardSettings] = useUpdateRewardSettingsMutation();
    const { data: cryptoResponse } = useGetCryptocurrencyQuery();

    const cryptocurrencies = cryptoResponse?.data || [];

    useEffect(() => {
        if (rewardSettings) {
            setEditData(rewardSettings);
        }
    }, [rewardSettings]);

    const handleEditSave = async () => {
        try {
            const response = await updateRewardSettings(editData).unwrap();
            if (response.status) {
                toast.success(response.message || "Reward settings updated successfully!");
                onHide();
            } else {
                toast.error(response.message || "Failed to update reward settings");
            }
        } catch (error) {
            toast.error("Error updating reward settings");
            console.error("Error updating reward settings:", error);
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('edit_reward_settings')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>{t('cryptocurrency')}</Form.Label>
                        <Form.Select
                            value={editData.reward_coin_id || ""}
                            onChange={(e) => setEditData({ ...editData, reward_coin_id: e.target.value })}
                        >
                            <option value="">{t('select_cryptocurrency')}</option>
                            {cryptocurrencies.map((crypto, index) => (
                                <option key={index} value={crypto.id}>
                                    {crypto.coin_name} ({crypto.symbol})
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>{t('amount')}</Form.Label>
                        <Form.Control
                            type="number"
                            step="any"
                            value={editData.reward_amount || ""}
                            onChange={(e) => setEditData({ ...editData, reward_amount: e.target.value })}
                        />
                    </Form.Group>


                    <Form.Group className="mb-3">
                        <Form.Label>{t('status')}</Form.Label>
                        <Form.Select
                            value={editData.status || "enabled"}
                            onChange={(e) => setEditData({ ...editData, status: e.target.value })}
                        >
                            <option value="enabled">{t('enabled')}</option>
                            <option value="disabled">{t('disabled')}</option>
                        </Form.Select>
                    </Form.Group>

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('close')}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                    {t('save_changes')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditRewardSettings;
